/*
 * @@Description: 行
 * @@Author: MuYang
 * @Date: 2021-07-28 10:57:30
 */

export default {
  name: 'SyBodyRow',
  inject: {
    table: { default: () => ({}) }
  },
  props: ['row', 'columns', 'rowIndex', 'syRowKey'],
  render (h) {
    const { syRowKey, columns, rowIndex } = this
    const { prefix } = this.table

    const rowProps = {
      key: syRowKey,
      class: `${prefix}-row ${prefix}-row-${rowIndex}`,
      attrs: { 'data-row-key': syRowKey },
      on: {
        mouseenter: e => {
          this.onMouseenter(e)
        },
        mouseleave: e => {
          this.onMouseleave(e)
        }
      }
    }
    return <tr {...rowProps}>{
      columns.map((column) => {
        return this.renderCell(column)
      })
    }</tr>
  },
  methods: {
    onMouseenter () {
      const fn = this.$listeners.hover
      fn && fn(true, this.syRowKey)
    },
    onMouseleave () {
      const fn = this.$listeners.hover
      fn && fn(false, this.syRowKey)
    },
    renderCell (column) {
      const { row, rowIndex } = this
      const { prefix } = this.table
      const {
        customRender,
        className = '',
        cellClassName = '',
        dataIndex,
        key,
        style
      } = column
      return (
        <td class={cellClassName} style={style}>
          <div class={`${prefix}-cell ${className}`}>
            {customRender &&
              customRender({
                row,
                column: {
                  dataIndex,
                  key
                },
                $index: rowIndex
              })}
          </div>
        </td>
      )
    }
  }
}
